import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Alert, Button, Form, ListGroup, Modal } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import { resetAllReminders } from '@severed-links/common.redherrings-reducers/terminatorAdmin'
import { REMINDER_BUTTONS } from '@severed-links/common.redherrings-constants'
import * as s from '../Eliminator/Admin/ResetAllEliminatorReminders.scss'
import terminatorErrorMessage from './terminatorErrorMessage'

const ResetAllTerminatorReminders = ({ seasonId, seasonName }) => {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const [preferences, setPreferences] = useState({})
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const open = () => {
    setPreferences(Object.fromEntries(REMINDER_BUTTONS.map(item => [item.fieldName, false])))
    setError(''); setMessage(''); setShow(true)
  }
  const save = async () => {
    if (busy) return
    setBusy(true)
    try {
      const action = await dispatch(resetAllReminders(seasonId, preferences))
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message)
      setMessage(action.payload.message); setShow(false)
    } catch (error) { setError(terminatorErrorMessage(error)) }
    setBusy(false)
  }
  return <div className={s.container}>
    <Button className={s.button} variant='light' disabled={!seasonId} onClick={open}><FontAwesomeIcon name='clock' /> Reset all reminders</Button>
    {message ? <Alert variant='success'>{message}</Alert> : null}
    <Modal show={show} onHide={() => { if (!busy) setShow(false) }} centered>
      <Modal.Header closeButton={!busy}><Modal.Title>Reset All {seasonName} Reminders</Modal.Title></Modal.Header>
      <Modal.Body>
        <p>Apply these preferences to every registered Terminator player for {seasonName}? Enabled channels will be turned on; disabled channels will be turned off. Delivery history stays unchanged.</p>
        {error ? <Alert variant='danger'>{error}</Alert> : null}
        <ListGroup className={s.reminderTypeList}>{REMINDER_BUTTONS.map(item => <ListGroup.Item className={s.item} key={item.fieldName}>
          <FontAwesomeIcon name={item.icon} className={s.icon} />
          <div className={s.content}>{item.title}</div>
          <Form.Check type='switch' aria-label={item.title} disabled={busy} checked={!!preferences[item.fieldName]} onChange={event => setPreferences({ ...preferences, [item.fieldName]: event.target.checked })} />
        </ListGroup.Item>)}</ListGroup>
      </Modal.Body>
      <Modal.Footer><Button variant='light' disabled={busy} onClick={() => setShow(false)}>Cancel</Button><Button disabled={busy} onClick={save}>{busy ? 'Saving…' : 'Apply to all players'}</Button></Modal.Footer>
    </Modal>
  </div>
}
export default ResetAllTerminatorReminders
